import React from 'react';

import { cn } from '@/lib/utils';

export interface ActivityBadgeProps {
  children: React.ReactNode;
  variant?: 'default';
  // | 'success' | 'warning' | 'error' | 'info';
  className?: string;
}

const variantClasses = {
  default: 'text-gray-700',
  // success: 'text-green-700',
  // warning: 'text-yellow-700',
  // error: 'text-red-700',
  // info: 'text-blue-700',
};

export const ActivityBadge: React.FC<ActivityBadgeProps> = ({
  children,
  variant = 'default',
  className,
}) => {
  return (
    <span
      className={cn(
        'inline-flex items-center px-2 py-1 text-xs font-medium',
        variantClasses[variant],
        className,
      )}
      style={{ backgroundColor: '#F5F5F5', borderRadius: '4px' }}
    >
      {children}
    </span>
  );
};
